import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

import classes from "../../App.module.css";
import imgUrl from "../../assets/images/imageUrl.js";
import CustomDrawer from "../../pages/template/CustomDrawer.js";
import Grid from "@material-ui/core/Grid";

import "../../assets/css/customstyles.css";
//import '../../assets/css/theme_grey.css'
import "../../assets/css/theme_blue.css";
//import '../../assets/css/theme_green.css'
//import '../../assets/css/theme_red.css'

import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";

import {
  Button,
  InputFieldFF,
  ReactFinalForm,
  hasValue,
  CircularLoader,
  CenteredContent,
} from "@dhis2/ui";
import { apiServices } from "../../services/apiServices";
import Alert from "@material-ui/lab/Alert";
import IconButton from "@material-ui/core/IconButton";
import Collapse from "@material-ui/core/Collapse";
import CloseIcon from "@material-ui/icons/Close";
import { useTranslation } from "react-i18next";
import swal from "sweetalert";

import Camera, { FACING_MODES, IMAGE_TYPES } from "react-html5-camera-photo";
import "react-html5-camera-photo/build/css/index.css";

import OfflineDb from "../../db";
import { useGlobalSpinnerActionsContext } from "../../context/GlobalSpinnerContext";
import { Typography } from "@material-ui/core";
import {
  loadCaptchaEnginge,
  LoadCanvasTemplate,
  LoadCanvasTemplateNoReload,
  validateCaptcha,
} from "react-simple-captcha";
import CustomCarousel from "../../component/logincarousel/CustomCarousel.js";
import _ from "lodash";

const { Form, Field } = ReactFinalForm;

function Login({ onSuccess }) {
  const [showPasswordFlag, setShowPassword] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const history = useHistory();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [keyboardonclick, setKeyboardOnclick] = React.useState(false);

  const { t, i18n } = useTranslation();
  useEffect(() => {
    i18n.changeLanguage("en");
    OfflineDb.getDataFromPouchDB("loginDetails").then((loginDetails) => {
      if (loginDetails.data != undefined) {
        // history.push("/layout/home")
        onSuccess();
      }
    });
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const latitude = position.coords.latitude;
          const longitude = position.coords.longitude;
          OfflineDb.setDataIntoPouchDB("geolocation", {
            lat: latitude,
            lng: longitude,
          });
          //alert("Geolocation R&D : "+latitude+' : '+longitude);
        },
        (error) => {
          // if geolocation denied by user then set default one
          OfflineDb.setDataIntoPouchDB("geolocation", {
            lat: 40.712742,
            lng: -74.013382,
          });
          //alert("Geolocation Error : "+error)
        }
      );
    } else {
      // if geolocation denied by user then set default one
      OfflineDb.setDataIntoPouchDB("geolocation", {
        lat: 40.712742,
        lng: -74.013382,
      });
    }
  }, []);

  useEffect(() => {
    // loadCaptchaEnginge(6, "#e0edf7");
    loadCaptchaEnginge(6, "#e0edf7", "#000", "numbers");
  }, []);

  function handleonfocus() {
    if (window.cordova) {
      setKeyboardOnclick(true);
    }
  }
  function handleonblur() {
    if (window.cordova) {
      setKeyboardOnclick(false);
    }
  }

  function handleBack() {
    history.push("/onboarding");
  }

  function onSubmit(values) {
    //setLoading(true)
    if (!window.cordova && !validateCaptcha(values.captcha)) {
      let captchaMsg = "Incorrect Captcha!";
      if (!values.captcha) {
        captchaMsg = "Enter Captcha!";
      }
      swal({
        title: t("Alert"),
        text: t(captchaMsg),
        icon: "warning",
        button: "Close",
      });
      return;
    }

    setGlobalSpinner(true);
    const Authorization =
      "Basic " + btoa(values.username.trim() + ":" + values.password.trim());
    localStorage.setItem("basicAuth", Authorization);
    OfflineDb.setDataIntoPouchDB("basicAuth", Authorization);
    apiServices
      .loginApi(Authorization)
      .then((res) => {
        OfflineDb.setDataIntoPouchDB("loginDetails", res.data).then((a) => {
          console.log(res.data, "res.data");
          if (res.data.userCredentials.disabled == true) {
            swal({
              title: "Login failed",
              text: "Account Disabled",
              icon: "error",
              button: "Close",
            });
            setGlobalSpinner(false);
            return;
          }
          apiServices
            .getAPI("dataStore/configuration/configuration_mrun")
            .then((res) => {
              apiServices
                .getAPI("dataStore/accessManagement/menuList")
                .then((roleData) => {
                  const transformed = _.reduce(
                    roleData.data,
                    (result, item) => {
                      // Get all keys except 'access'
                      const { access, ...rest } = item;

                      // Add the remaining keys to the result object using access as key
                      result[access] = rest;
                      return result;
                    },
                    {}
                  );
                  res.data.configuration["roleAccess"] = transformed;
                  OfflineDb.setDataIntoPouchDB("configurations", res.data);
                  setGlobalSpinner(false);
                  setTimeout(() => {
                    history.push("/selectlanguage");
                  }, 500);
                });
            })
            .catch((error) => {
              setGlobalSpinner(false);
              history.push("/selectlanguage");
            });
        });
      })
      .catch((error) => {
        if (error.response) {
          swal({
            title: "Login failed",
            text: error.response.data.message + " Or Account Disabled",
            icon: "error",
            button: "Close",
          });
        } else {
          swal({
            title: "Login failed",
            text: "",
            icon: "error",
            button: "Close",
          });
        }
        //setLoading(false)
        setGlobalSpinner(false);
      });
  }

  function doForgotPasswordRecoveryCall(username) {
    var bodyFormData = new FormData();
    bodyFormData.append("username", username);
    const url = "account/recovery";
    setLoading(true);
    apiServices
      .postMultiPartFormDataAPI(url, bodyFormData)
      .then((res) => {
        setLoading(false);
        swal({
          title: "Done",
          text: res.data.message,
          icon: "success",
          button: "Close",
        });
      })
      .catch((err) => {
        if (err.response) {
          swal({
            title: "Fail",
            text: err.response.data.message,
            icon: "error",
            button: "Close",
          });
        } else {
          swal({
            title: "Fail",
            text: "Fail to update",
            icon: "error",
            button: "Close",
          });
        }
        setLoading(false);
      });
  }

  const updatePassword = (email, password) => {
    const body = {
      email,
      password,
    };
    const url = "rtmpro/subscribe/updatePassword";
    setLoading(true);

    apiServices
      .postAPI(url, body)
      .then((res) => {
        setLoading(false);
        if (res.data.status === "success") {
          console.log("res", res);
          swal({
            title: "Success",
            text: "Password updated successfully",
            icon: "success",
            button: "Close",
          });
        } else {
          swal({
            title: "Fail",
            text: "Fail to update",
            icon: "error",
            button: "Close",
          });
        }
      })
      .catch((err) => {
        console.log("err", err);
        if (err.response) {
          swal({
            title: "Fail",
            text: err.response.data.message,
            icon: "error",
            button: "Close",
          });
        } else {
          swal({
            title: "Fail",
            text: "Fail to update",
            icon: "error",
            button: "Close",
          });
        }
        setLoading(false);
      });
  };

  const validateToken = (username, token) => {
    const body = {
      username,
      token,
    };
    const url = "save/mfa/user/validate/token";
    setLoading(true);

    apiServices
      .postAPI(url, body)
      .then((res) => {
        setLoading(false);
        if (res.data.status === "success") {
          console.log("res", res);

          swal({
            text: "Please enter new password",
            content: "input",
            buttons: ["Cancel", "Submit"],
          }).then((password) => {
            if (password) {
              updatePassword(username, password);
            }
          });
        } else {
          swal({
            title: "Fail",
            text: "Fail to update",
            icon: "error",
            button: "Close",
          });
        }
      })
      .catch((err) => {
        console.log("err", err);
        if (err.response) {
          swal({
            title: "Fail",
            text: err.response.data.message,
            icon: "error",
            button: "Close",
          });
        } else {
          swal({
            title: "Fail",
            text: "Fail to update",
            icon: "error",
            button: "Close",
          });
        }
        setLoading(false);
      });
  };

  const getToken = (username) => {
    const body = {
      status: "1",
      username,
      userrole: "",
      userid: "",
    };
    const url = "save/mfa/user/send/token";
    setLoading(true);

    apiServices
      .postAPI(url, body)
      .then((res) => {
        setLoading(false);
        if (res.data.status === "success") {
          swal({
            text: "Please enter token",
            content: "input",
            buttons: ["Cancel", "Submit"],
          }).then((token) => {
            if (token) {
              validateToken(username, token);
            }
          });
        } else {
          swal({
            title: "Fail",
            text: "Fail to update",
            icon: "error",
            button: "Close",
          });
        }
        console.log("res", res);
      })
      .catch((err) => {
        console.log("err", err);
        if (err.response) {
          swal({
            title: "Fail",
            text: err.response.data.message,
            icon: "error",
            button: "Close",
          });
        } else {
          swal({
            title: "Fail",
            text: "Fail to update",
            icon: "error",
            button: "Close",
          });
        }
        setLoading(false);
      });
  };

  function openForgotPasswordPopup() {
    swal({
      text: "Please enter username",
      content: "input",
      buttons: ["Cancel", "Submit"],
    }).then((username) => {
      if (username) {
        // doForgotPasswordRecoveryCall(username);
        getToken(username);
      }
    });
  }

  function showPassword() {
    if (showPasswordFlag) {
      setShowPassword(false);
    } else {
      setShowPassword(true);
    }
  }
  const regex = new RegExp("^[a-zA-Z0-9_@.]*$");
  const scriptBlockRegex = new RegExp("/<[^>]*>/g");
  const passwordRegex = new RegExp(
    "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
  );
  const required = (value) => (value ? undefined : "Required");
  const userCheck = (value) =>
    value
      ? value.match(regex) != null
        ? undefined
        : "Incorrect expression added as input"
      : undefined;
  const scriptCheck = (value) =>
    value
      ? value.match(scriptBlockRegex) != null
        ? 'Incorrect expression "< or >" added as input'
        : undefined
      : undefined;
  const passWordCheck = (value) =>
    value
      ? value.match(passwordRegex) != null
        ? undefined
        : "Incorrect password pattern"
      : undefined;
  const composeValidators =
    (...validators) =>
    (value) =>
      validators.reduce(
        (error, validator) => error || validator(value),
        undefined
      );

  return (
    <div className={classes.container}>
      <main style={{ display: "flex", height: "100%", width: "100%" }}>
        <section
          className="mainsection pb-0 homeMain"
          style={{
            flexGrow: 1,
          }}
        >
          <Grid container className="loginnav">
            {/* 
                        <Grid xs={3} className='backimg'><img src={imgUrl.back} className='backsvg' onClick={() => handleBack()}
                        /></Grid> */}
            <Grid item xs={6} className="text-center">
              {/* <Typography variant='subtitle1' className='logname oneuhcfont'>Login</Typography> */}
            </Grid>
            <Grid item xs={3}></Grid>
          </Grid>
          <Grid container className="lognewDIv">
            <Grid item xs={12} md={6} className="carousel-side">
              <CustomCarousel />
            </Grid>
            <Grid
              item
              xs={12}
              md={5}
              className="loginpageformholder"
              style={{ marginLeft: "2%" }}
            >
              <div className="innerdiv userwebapp">
                <p className="zero text-center">
                  {/* <div className="useravtarimg" /> */}
                </p>
                <p className="zero text-center">
                  {/* <h3 className="text-uppercase">Sign In</h3> */}
                </p>
              </div>
              <div className="loginpageformholder loginwebhome">
                <div className="logintext">
                  <div className="login-wrapper">
                    <div className="login-header-logos">
                      {/* <img src={imgUrl.dpworldlogo} alt="Logo 1" /> */}
                      {/* <img src={imgUrl.swasthlogo} alt="Logo 2" /> */}
                      <img src={imgUrl.planindialogo} alt="Plan India" />
                    </div>
                  </div>

                  {/* <div className="useravtarimgapp" /> */}
                  {/* <Typography variant='h4' className='signmob mb-30px'>Sign In</Typography> */}
                </div>
                <div className="loginwweb">
                  {/* <Typography variant='h4' className='signweb mb-30px'>Sign In</Typography> */}
                  {/* <p className="loginformheading">Sign In</p> */}
                  {loading ? (
                    <CenteredContent
                      dataTest="dhis2-uicore-centeredcontent"
                      position="middle"
                    >
                      <CircularLoader
                        large
                        dataTest="dhis2-uicore-circularloader"
                      />
                    </CenteredContent>
                  ) : (
                    ""
                  )}
                  <Form
                    // initialValues={{
                    //   username: "142188_healthworker1@tpttest.org",
                    //   password: "Test@123",
                    // }}
                    autoComplete="off"
                    onSubmit={(values) => onSubmit(values, null, 2)}
                    render={({
                      handleSubmit,
                      form,
                      submitting,
                      pristine,
                      values,
                    }) => (
                      <form
                        onSubmit={handleSubmit}
                        autoComplete="off"
                        style={{ display: "contents" }}
                      >
                        <div className="w-100">
                          <Field
                            name="username"
                            label="User Name"
                            component={InputFieldFF}
                            key="username"
                            validate={composeValidators(
                              required,
                              userCheck,
                              scriptCheck
                            )}
                            required
                          />
                        </div>
                        <div className="w-100">
                          <Field
                            name="password"
                            label="Password"
                            component={InputFieldFF}
                            key="password"
                            validate={composeValidators(
                              required,
                              scriptCheck,
                              passWordCheck
                            )}
                            required
                            className={showPasswordFlag ? "" : "password"}
                          />
                          <p className="visibilityiconcontainer">
                            {!showPasswordFlag ? (
                              <VisibilityIcon onClick={() => showPassword()} />
                            ) : (
                              <VisibilityOffIcon
                                onClick={() => showPassword()}
                              />
                            )}
                          </p>
                        </div>

                        <p
                          className="forgotpw"
                          style={{ cursor: "pointer" }}
                          onClick={() => openForgotPasswordPopup()}
                        >
                          Forgot Password?
                        </p>

                        <div className="captchadiv">
                          <div className="w-100 captchaContainer">
                            <LoadCanvasTemplate />
                            {/* <img src={imgUrl.captcha}></img> */}
                          </div>
                          <div className="w-100">
                            <Field
                              name="captcha"
                              // label='User Name'
                              placeholder="Enter Captcha"
                              component={InputFieldFF}
                              key="captcha"
                              className="fieldfont"
                              //validate={composeValidators(required)}
                              onFocus={() => handleonfocus()}
                              onBlur={() => handleonblur()}
                            />
                          </div>
                        </div>

                        <div className="buttons">
                          <Button
                            type="submit"
                            disabled={submitting}
                            className="loginbtn loginsubmitbtn mrunnerLoginbtn"
                          >
                            Login
                          </Button>
                          &nbsp;
                          <Button
                            type="button"
                            onClick={form.reset}
                            disabled={submitting || pristine}
                            className="resetButton mrunnerResetbtn"
                          >
                            Reset
                          </Button>
                        </div>

                        <div
                          style={{
                            marginTop: "12px",
                            fontSize: "12px",
                            textAlign: "end",
                          }}
                        >
                          {t("Version No")} : 1.0.0{" "}
                        </div>
                      </form>
                    )}
                  />
                </div>
              </div>
            </Grid>

            <Grid item xs={12} md={4} className="pagelaterpart">
              <div className="custom-shape-divider-top-1612935135">
                <svg
                  data-name="Layer 1"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 1200 120"
                  preserveAspectRatio="none"
                >
                  <path
                    d="M600,112.77C268.63,112.77,0,65.52,0,7.23V120H1200V7.23C1200,65.52,931.37,112.77,600,112.77Z"
                    className="shape-fill"
                  ></path>
                </svg>
              </div>
            </Grid>
          </Grid>
        </section>
      </main>
    </div>
  );
}

export default Login;
